import AreaMarker from '@/components/CustomComponent/AreaMarker';
import CustomDropdown from '@/components/CustomComponent/CustomDropdown/CustomDropdown';
import CustomMultiSelect from '@/components/CustomComponent/CustomMultiSelect';
import DeviceMarker from '@/components/CustomComponent/DeviceMarker';
import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';

import ImageAreaMarker from '@/components/CustomComponent/ReactImageAreaMarker';
import { COMMON_TEXT } from '@/helpers/common-text';
import {
  DEVICE_CATEGORY,
  MEMORY_STORE,
  QUERY_STRING_STORE,
} from '@/helpers/constants';
import {
  calculateRectangle,
  generateRandomString,
  getConfigurationUrlWithParam,
  transformCoordinateBottomLeftToTopLeft,
  transformRectangleToAreaPosition,
} from '@/helpers/utility';
import { cloneDeep, isEqual } from 'lodash';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  addDevicePositionToDevices,
  getAreasByFloorId,
  getBranchesByTenantId,
  getButlrDevicesByTenantId,
  getDevicePositionsByFloorId,
  getFloorsByBranchIdList,
  // getMerakiDevicesByTenantIdAndModel,
  getVerkadaDevicesByFloorIdAndDeviceType,
  getWebexDevicesByTenantId,
  setDevicePositionToMap,
  updateAreaInfo,
} from './service';
import fileService from '@/services/file-service';
import Toaster from 'src/components/CustomComponent/Toaster';
import SaveButton from 'src/components/CustomComponent/SaveButton/SaveButton';

const UPDATE_AREA_STATUS = {
  DELETED: 'DELETED',
  MODIFIED: 'MODIFIED',
  NEW: 'NEW',
};

@connect(state => ({
  tenantId: state.session?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class AreaSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      isUpdating: false,
      branchList: [],
      floorList: [],
      verkadaDevicesList: [],
      merakiDevicesList: [],
      butlrDevicesList: [],
      webexDevicesList: [],
      areaList: [],
      isLoadingDevice: false,
      deviceMarkerPositionList: [],
      selectedFloorBranch: null,
      floorMapUrl: '',
      floorMapError: false,
      isFloorMapLoading: false,
      deviceAreaTabIndex: 0,
      isUpdateDialogVisible: false,
      updateDataPayload: { values: [] },
      selectedArea: null,
      isDeviceAreaDialogVisible: false,
      showCameraMarkerCategories: [],
      selectedDeviceCategory: DEVICE_CATEGORY.VERKADA,
    };
    this.toastRef = React.createRef();
    this.areaListContainerRef = React.createRef();
    this.areaListStateMap = {};
    this.originData = {
      // key = floor_id, data is verkadaDevicesList: [],
      // merakiDevicesList: [],
      // areaList: [],
      // deviceMarkerPositionList: [],
    }; // to store the original device list
    this.orgSelectedMerakiDevicesList = [];
    this.orgSelectedVerkadaDevicesList = [];
    this.orgSelectedButlrDevicesList = [];
    this.orgSelectedWebexDevicesList = [];
    this.payloadTableData = {
      // key = floor_id, data is newAreaList, deletedAreaList, modifiedAreaList
    };
    this.deviceCategoryOptions = [
      // { label: 'Meraki', value: DEVICE_CATEGORY.MERAKI },
      { label: 'Verkada', value: DEVICE_CATEGORY.VERKADA },
      { label: 'Butlr', value: DEVICE_CATEGORY.BUTLR },
      { label: 'Webex', value: DEVICE_CATEGORY.WEBEX },
    ];
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.getData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    if (isTenantChanged) {
      this.setState({ tenant }, () => {
        this.setState({ deviceList: [] });
        this.getData();
      });
    }
  }

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  getData = async () => {
    this.setState({
      isLoading: true,
      isFloorMapLoading: true,
      isLoadingDevice: true,
    });
    await getBranchesByTenantId({ tenantId: this.state.tenant }).then(
      branchList => {
        if (branchList && branchList.length > 0) {
          this.setState({ branchList });
          const branchIdList = this.state.branchList.map(
            branch => branch.branch_id
          );
          getFloorsByBranchIdList({ branchIdList }).then(floorList => {
            const sortedFloorListByBranchOrder = floorList.sort(
              (a, b) =>
                branchIdList.indexOf(a.branch_id) -
                branchIdList.indexOf(b.branch_id)
            );
            if (floorList && floorList.length > 0) {
              this.setState(
                {
                  floorList: sortedFloorListByBranchOrder,
                  selectedFloorBranch: sortedFloorListByBranchOrder[0],
                },
                () => {
                  this.getFloorMapUrl(this.state.selectedFloorBranch.floor_id);
                  this.getDeviceList({
                    selectedFloorBranch: this.state.selectedFloorBranch,
                    selectedTenantId: this.state.tenant,
                  });
                }
              );
            }
          });
        }
      }
    );

    this.setState({
      isLoading: false,
    });
  };

  getFloorMapUrl = async floorId => {
    const floors = this.props?.sessionStore[MEMORY_STORE.FLOORS] || [];
    const floor = floors.find(floor => floor.floor_id === floorId);

    if (!floor?.floor_map) {
      this.setState({
        floorMapUrl: '',
        floorMapError: true,
        isFloorMapLoading: false,
      });
      return;
    }

    try {
      // Get floor map URL using the file service
      const url = await fileService.getFileUrl(floor.floor_map, this.props.tenantId);

      this.validateFloorMapUrl(
        url,
        () => {
          this.setState({
            floorMapUrl: url,
            floorMapError: false,
            isFloorMapLoading: false,
          });
        },
        () => {
          this.setState({
            floorMapUrl: '',
            floorMapError: true,
            isFloorMapLoading: false,
          });
        }
      );
    } catch (error) {
      console.error('Failed to fetch floor map URL:', error);
      this.setState({
        floorMapUrl: '',
        floorMapError: true,
        isFloorMapLoading: false,
      });
    }
  };

  validateFloorMapUrl(url, successCallback, errorCallback) {
    var img = new Image();
    img.onload = function () {
      successCallback(url);
    };
    img.onerror = function () {
      errorCallback(url);
    };
    img.src = url;
  }

  getDeviceList = async ({ selectedFloorBranch, selectedTenantId }) => {
    this.setState({ isLoadingDevice: true });
    const floorId = selectedFloorBranch.floor_id;
    const areaListState = this.retrieveAreaListStateByFloorId({
      floorId,
    });
    let verkadaDevicesList = [];
    let merakiDevicesList = [];
    let butlrDevicesList = [];
    let webexDevicesList = [];
    let deviceMarkerPositionList = [];
    let areaList = [];

    if (areaListState) {
      verkadaDevicesList = cloneDeep(areaListState.verkadaDevicesList);
      merakiDevicesList = cloneDeep(areaListState.merakiDevicesList);
      butlrDevicesList = cloneDeep(areaListState.butlrDevicesList);
      webexDevicesList = cloneDeep(areaListState.webexDevicesList);
      areaList = cloneDeep(areaListState.areaList);
      deviceMarkerPositionList = cloneDeep(
        areaListState.deviceMarkerPositionList
      );
    } else {
      // Fetch device positions
      const devicePositions = await getDevicePositionsByFloorId({ floorId });
      // Fetch verkada devices
      let verkadaList = await getVerkadaDevicesByFloorIdAndDeviceType({
        floorId,
        deviceType: 'camera',
      });
      verkadaList = addDevicePositionToDevices({
        devices: verkadaList,
        deviceCategory: DEVICE_CATEGORY.VERKADA,
        devicePositions,
      });
      // Fetch meraki devices
      let merakiList = []; // temporary remove meraki list, not fetching
      // let merakiList = await getMerakiDevicesByTenantIdAndModel({
      //   tenantId: selectedTenantId,
      //   model: 'MV',
      // });
      // merakiList = addDevicePositionToDevices({
      //   devices: merakiList,
      //   deviceCategory: DEVICE_CATEGORY.MERAKI,
      //   devicePositions,
      // });

      // Fetch butlr devices
      let butlrList = await getButlrDevicesByTenantId({
        tenantId: selectedTenantId,
      });
      butlrList = addDevicePositionToDevices({
        devices: butlrList,
        deviceCategory: DEVICE_CATEGORY.BUTLR,
        devicePositions,
      });
      // Fetch webex devices
      let webexList = await getWebexDevicesByTenantId({
        tenantId: selectedTenantId,
      });
      webexList = addDevicePositionToDevices({
        devices: webexList,
        deviceCategory: DEVICE_CATEGORY.WEBEX,
        devicePositions,
      });

      // Fetch area list
      const areaListResponse = await getAreasByFloorId({ floorId });
      // Calculate area marker position
      for (const area of areaListResponse) {
        const { position_x, position_y, position_x1, position_y1 } = area;
        const { pointC, width, height } = calculateRectangle({
          positionX: position_x,
          positionY: position_y,
          positionX1: position_x1,
          positionY1: position_y1,
        });
        const { x, y } = transformCoordinateBottomLeftToTopLeft({
          x: pointC.x,
          y: pointC.y,
        });
        area.rect = {
          top: y,
          left: x,
          width,
          height,
        };
      }

      verkadaDevicesList = cloneDeep(verkadaList);
      merakiDevicesList = cloneDeep(merakiList);
      butlrDevicesList = cloneDeep(butlrList);
      webexDevicesList = cloneDeep(webexList);

      deviceMarkerPositionList.push(
        ...setDevicePositionToMap({ deviceList: merakiDevicesList })
      );
      deviceMarkerPositionList.push(
        ...setDevicePositionToMap({ deviceList: verkadaDevicesList })
      );
      deviceMarkerPositionList.push(
        ...setDevicePositionToMap({ deviceList: butlrDevicesList })
      );
      deviceMarkerPositionList.push(
        ...setDevicePositionToMap({ deviceList: webexDevicesList })
      );

      const deviceMarkerPositionMapByAreaId = {};
      deviceMarkerPositionList.forEach((deviceMarkerItem, index) => {
        const { device } = deviceMarkerItem;
        const { area_id } = device;
        if (area_id) {
          if (!deviceMarkerPositionMapByAreaId[area_id]) {
            deviceMarkerPositionMapByAreaId[area_id] = [];
          }
          deviceMarkerPositionMapByAreaId[area_id].push(device);
        }
      });

      areaListResponse.forEach(area => {
        const { area_id } = area;
        if (deviceMarkerPositionMapByAreaId[area_id]) {
          area.device_positions = deviceMarkerPositionMapByAreaId[area_id];
        } else {
          area.device_positions = [];
        }
      });

      areaList = cloneDeep(areaListResponse);

      // Save to areaListStateMap
      this.areaListStateMap[floorId] = {
        deviceMarkerPositionList,
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
        areaList,
      };

      // Save original data
      this.originData[+floorId] = {
        verkadaDevicesList: cloneDeep(verkadaDevicesList),
        merakiDevicesList: cloneDeep(merakiDevicesList),
        butlrDevicesList: cloneDeep(butlrDevicesList),
        webexDevicesList: cloneDeep(webexDevicesList),
        areaList: cloneDeep(areaListResponse),
        deviceMarkerPositionList: cloneDeep(deviceMarkerPositionList),
      };
    }
    this.setState({
      verkadaDevicesList,
      merakiDevicesList,
      deviceMarkerPositionList,
      butlrDevicesList,
      webexDevicesList,
      areaList,
      isLoadingDevice: false,
    });
  };

  getBranchName = branchId => {
    if (branchId) {
      const branch = this.state.branchList.filter(
        branch => branch.branch_id === branchId
      );
      return branch[0].branch_name + ' - ';
    }
  };

  onChangeSelectedFloorAction = selectedFloorBranch => {
    this.updateMarkerPosition({
      floorId: this.state.selectedFloorBranch.floor_id,
      areaList: this.state.areaList,
      deviceMarkerPositionList: this.state.deviceMarkerPositionList,
      merakiDevicesList: this.state.merakiDevicesList,
      verkadaDevicesList: this.state.verkadaDevicesList,
      webexDevicesList: this.state.webexDevicesList,
      butlrDevicesList: this.state.butlrDevicesList,
    });
    this.setState({ selectedFloorBranch, isFloorMapLoading: true }, () => {
      this.getFloorMapUrl(selectedFloorBranch.floor_id);
      this.getDeviceList({
        selectedFloorBranch,
        selectedTenantId: this.state.tenant,
      });
    });
  };

  retrieveAreaListStateByFloorId = ({ floorId }) => {
    return this.areaListStateMap[floorId] || null;
  };

  updateMarkerPosition = ({
    floorId,
    areaList,
    deviceMarkerPositionList,
    merakiDevicesList,
    verkadaDevicesList,
    butlrDevicesList,
    webexDevicesList,
  }) => {
    floorId = +floorId;
    this.areaListStateMap[floorId] = {
      deviceMarkerPositionList: cloneDeep(deviceMarkerPositionList),
      merakiDevicesList: cloneDeep(merakiDevicesList),
      verkadaDevicesList: cloneDeep(verkadaDevicesList),
      butlrDevicesList: cloneDeep(butlrDevicesList),
      webexDevicesList: cloneDeep(webexDevicesList),
      areaList: cloneDeep(areaList),
    };
  };

  updateButtonOnClicked = () => {
    const isAreaChanged = ({ orgArea, newArea }) => {
      const {
        area_name: orgAreaName,
        capacity_limit: orgCapacityLimit,
        device_positions: orgDevicePositions,
        rect: orgRect,
      } = orgArea;
      const {
        area_name: newAreaName,
        capacity_limit: newCapacityLimit,
        device_positions: newDevicePositions,
        newRect,
      } = newArea;
      if (
        orgAreaName !== newAreaName ||
        orgCapacityLimit !== newCapacityLimit ||
        !isEqual(orgDevicePositions, newDevicePositions)
      ) {
        return true;
      }
      if (newRect && !isEqual(orgRect, newRect)) {
        return true;
      }
      return false;
    };
    this.updateMarkerPosition({
      floorId: this.state.selectedFloorBranch.floor_id,
      areaList: this.state.areaList,
      deviceMarkerPositionList: this.state.deviceMarkerPositionList,
      merakiDevicesList: this.state.merakiDevicesList,
      verkadaDevicesList: this.state.verkadaDevicesList,
      butlrDevicesList: this.state.butlrDevicesList,
      webexDevicesList: this.state.webexDevicesList,
    });

    const updatePayload = {
      values: [],
    };
    for (const floorId in this.areaListStateMap) {
      const stateData = this.areaListStateMap[+floorId];
      if (!stateData) {
        continue;
      }
      const {
        areaList,
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      } = stateData;
      const originData = this.originData[+floorId];
      const { areaList: originAreaList } = originData;

      const newAreaList = [];
      const deletedAreaList = [];
      const modifiedAreaList = [];

      for (const areaItem of areaList) {
        const area = cloneDeep(areaItem);

        // Update area rect
        if (area.newRect) {
          const newPosition = transformRectangleToAreaPosition(area.newRect);
          area.position_x = newPosition.position_x;
          area.position_y = newPosition.position_y;
          area.position_x1 = newPosition.position_x1;
          area.position_y1 = newPosition.position_y1;
        }
        // delete unused properties
        delete area.isEdit;

        const devicePositions = [];
        const filteredMerakiDevicesList = merakiDevicesList
          ? merakiDevicesList.filter(item => item.area_id === area.area_id)
          : [];
        const filteredVerkadaDevicesList = verkadaDevicesList
          ? verkadaDevicesList.filter(item => item.area_id === area.area_id)
          : [];
        const filteredButlrDevicesList = butlrDevicesList
          ? butlrDevicesList.filter(item => item.area_id === area.area_id)
          : [];
        const filteredWebexDevicesList = webexDevicesList
          ? webexDevicesList.filter(item => item.area_id === area.area_id)
          : [];
        const filteredDeviceList = [
          ...filteredMerakiDevicesList,
          ...filteredVerkadaDevicesList,
          ...filteredButlrDevicesList,
          ...filteredWebexDevicesList,
        ];

        // Update new device position value
        filteredDeviceList.forEach(device => {
          devicePositions.push(device);
        });
        area.device_positions = devicePositions;

        if (area.is_new && !area.is_deleted) {
          // process new area
          newAreaList.push(area);
        } else if (!area.is_new & area.is_deleted && area.position_x === null) {
          // process deleted area
          deletedAreaList.push(area);
        } else {
          // process modified area
          const orgArea = originAreaList.find(
            originArea => originArea.area_id === area.area_id
          );
          // check if area is modified
          if (orgArea && isAreaChanged({ orgArea, newArea: area })) {
            modifiedAreaList.push(area);
          }
        }
      }

      const areaValues = [];
      if (newAreaList.length > 0) {
        for (const area of newAreaList) {
          let devicePositions = [];
          if (area.device_positions) {
            devicePositions = area.device_positions.map(
              item => item.device_position_id
            );
          }
          areaValues.push({
            area_id: null,
            area_name: area.area_name,
            position_x: area.position_x,
            position_y: area.position_y,
            position_x1: area.position_x1,
            position_y1: area.position_y1,
            capacity_limit: area.capacity_limit,
            floor_id: area.floor_id,
            device_positions: devicePositions,
          });
        }
      }

      if (deletedAreaList.length > 0) {
        for (const area of deletedAreaList) {
          areaValues.push({
            area_id: area.area_id,
            position_x: null,
          });
        }
      }

      if (modifiedAreaList.length > 0) {
        for (const area of modifiedAreaList) {
          let devicePositions = [];
          if (area.device_positions) {
            devicePositions = area.device_positions.map(
              item => item.device_position_id
            );
          }
          areaValues.push({
            area_id: area.area_id,
            area_name: area.area_name,
            position_x: area.position_x,
            position_y: area.position_y,
            position_x1: area.position_x1,
            position_y1: area.position_y1,
            capacity_limit: area.capacity_limit,
            floor_id: area.floor_id,
            device_positions: devicePositions,
          });
        }
      }
      if (areaValues.length > 0) {
        updatePayload.values.push({
          floor_id: +floorId,
          areas: areaValues,
        });
        // Update data to be displayed in table dialog
        this.payloadTableData[+floorId] = {
          newAreaList,
          deletedAreaList,
          modifiedAreaList,
        };
      }
    }
    if (updatePayload.values.length > 0) {
      this.setState({
        isUpdateDialogVisible: true,
        updateDataPayload: updatePayload,
      });
    } else {
      this.toastRef.current.show({
        severity: 'info',
        summary: '情報',
        detail: COMMON_TEXT.NO_CHANGE_TO_BE_SAVED,
        life: 3000,
        closable: true,
      });
    }
  };

  saveMarkPosition = ({ updateDataPayload }) => {
    if (updateDataPayload.values.length > 0) {
      this.updateData({ updatePayLoad: updateDataPayload });
    }
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    const { isSuccess } = await updateAreaInfo({
      updatePayLoad,
      tenantId: this.props.tenantId,
    });

    if (isSuccess) {
      this.setState({ isUpdating: false, isUpdateDialogVisible: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        // Clear the originData to force fresh data fetch
        this.originData = {};
        this.areaListStateMap = {};
        this.getData();
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  renderAreaMarker = props => {
    return <AreaMarker {...props}></AreaMarker>;
  };

  renderMapMarker = props => {
    const { isDelete, device } = props;
    if (isDelete) {
      return <></>;
    }
    if (device) {
      const { device } = props;
      const randomTooltipString = generateRandomString(10);
      if (device) {
        const { device_name } = device;
        return (
          <>
            <Tooltip
              target={`.map-marker-id-${randomTooltipString}`}
              mouseTrack
              mouseTrackLeft={10}
            />
            <DeviceMarker
              deviceinfo={device}
              className={[
                `pi pi-map-marker map-marker-style map-marker-id-${randomTooltipString}`,
              ]}
              data-pr-tooltip={device_name}
              data-pr-classname="child-div-tooltip"
            />
          </>
        );
      }
    }
    return <></>;
  };

  renderDeviceListNew = ({ selectedArea }) => {
    const {
      merakiDevicesList,
      verkadaDevicesList,
      butlrDevicesList,
      webexDevicesList,
      selectedDeviceCategory,
    } = this.state;

    const addDeviceToArea = ({ device }) => {
      const { deviceCategory, device_identifer } = device;
      if (deviceCategory === DEVICE_CATEGORY.MERAKI) {
        const idx = merakiDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx > -1) {
          merakiDevicesList[idx].area_id = selectedArea.area_id;
          merakiDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.VERKADA) {
        const idx = verkadaDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx > -1) {
          verkadaDevicesList[idx].area_id = selectedArea.area_id;
          verkadaDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.BUTLR) {
        const idx = butlrDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx !== -1) {
          butlrDevicesList[idx].area_id = selectedArea.area_id;
          butlrDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.WEBEX) {
        const idx = webexDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx !== -1) {
          webexDevicesList[idx].area_id = selectedArea.area_id;
          webexDevicesList[idx].area_name = selectedArea.area_name;
        }
      }
      this.setState({
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      });
    };

    const removeDeviceFromArea = ({ device }) => {
      const { deviceCategory, device_identifer } = device;
      if (deviceCategory === DEVICE_CATEGORY.MERAKI) {
        const foundIndex = merakiDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          merakiDevicesList[foundIndex].area_id = null;
          merakiDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.VERKADA) {
        const foundIndex = verkadaDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          verkadaDevicesList[foundIndex].area_id = null;
          verkadaDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.BUTLR) {
        const foundIndex = butlrDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          butlrDevicesList[foundIndex].area_id = null;
          butlrDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.WEBEX) {
        const foundIndex = webexDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          webexDevicesList[foundIndex].area_id = null;
          webexDevicesList[foundIndex].area_name = '';
        }
      }
      this.setState({
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      });
    };

    let deviceList = [];
    switch (selectedDeviceCategory) {
      case DEVICE_CATEGORY.MERAKI:
        deviceList = merakiDevicesList || [];
        break;
      case DEVICE_CATEGORY.VERKADA:
        deviceList = verkadaDevicesList || [];
        break;
      case DEVICE_CATEGORY.BUTLR:
        deviceList = butlrDevicesList || [];
        break;
      case DEVICE_CATEGORY.WEBEX:
        deviceList = webexDevicesList || [];
        break;
      default:
        break;
    }

    deviceList = deviceList.filter(item => item.hasPosition);

    return deviceList.length > 0 ? (
      <div className="device-list-new">
        {deviceList.map((device, index) => (
          <div className="device-item-new" key={`device-item-${index}`}>
            <div className="device-icon">
              <i className="pi pi-map-marker device-pin-icon"></i>
            </div>
            <div className="device-info">
              <div className="device-name-new">{device.device_name}</div>
            </div>
            <div className="device-area">
              {device.area_id ? device.area_name : ''}
            </div>
            <div className="device-action">
              {device.area_id ? (
                <Button
                  className="device-action-btn remove-btn"
                  text
                  onClick={() => removeDeviceFromArea({ device })}
                >
                  <img
                    src="assets/img/circle-reload-icon.svg"
                    alt="Remove"
                    className="action-icon"
                  />
                </Button>
              ) : (
                <Button
                  className="device-action-btn add-btn"
                  text
                  onClick={() => addDeviceToArea({ device })}
                >
                  <img
                    src="assets/img/circle-plus-icon.svg"
                    alt="Add"
                    className="action-icon"
                  />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="no-data-container">
        {COMMON_TEXT.NO_DATA}
      </div>
    );
  };

  renderDeviceList = ({ selectedArea }) => {
    const {
      merakiDevicesList,
      verkadaDevicesList,
      butlrDevicesList,
      webexDevicesList,
      selectedDeviceCategory,
    } = this.state;
    const addDeviceToArea = ({ device }) => {
      const { deviceCategory, device_identifer } = device;
      if (deviceCategory === DEVICE_CATEGORY.MERAKI) {
        const idx = merakiDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx > -1) {
          merakiDevicesList[idx].area_id = selectedArea.area_id;
          merakiDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.VERKADA) {
        const idx = verkadaDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx > -1) {
          verkadaDevicesList[idx].area_id = selectedArea.area_id;
          verkadaDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.BUTLR) {
        const idx = butlrDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx !== -1) {
          butlrDevicesList[idx].area_id = selectedArea.area_id;
          butlrDevicesList[idx].area_name = selectedArea.area_name;
        }
      } else if (deviceCategory === DEVICE_CATEGORY.WEBEX) {
        const idx = webexDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (idx !== -1) {
          webexDevicesList[idx].area_id = selectedArea.area_id;
          webexDevicesList[idx].area_name = selectedArea.area_name;
        }
      }
      this.setState({
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      });
    };
    const removeDeviceFromArea = ({ device }) => {
      const { deviceCategory, device_identifer } = device;
      if (deviceCategory === DEVICE_CATEGORY.MERAKI) {
        const foundIndex = merakiDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          merakiDevicesList[foundIndex].area_id = null;
          merakiDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.VERKADA) {
        const foundIndex = verkadaDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          verkadaDevicesList[foundIndex].area_id = null;
          verkadaDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.BUTLR) {
        const foundIndex = butlrDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          butlrDevicesList[foundIndex].area_id = null;
          butlrDevicesList[foundIndex].area_name = '';
        }
      } else if (deviceCategory === DEVICE_CATEGORY.WEBEX) {
        const foundIndex = webexDevicesList.findIndex(
          item => item.device_identifer === device_identifer
        );
        if (foundIndex !== -1) {
          webexDevicesList[foundIndex].area_id = null;
          webexDevicesList[foundIndex].area_name = '';
        }
      }
      this.setState({
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      });
    };

    let deviceList = [];
    switch (selectedDeviceCategory) {
      case DEVICE_CATEGORY.MERAKI:
        deviceList = merakiDevicesList || [];
        break;
      case DEVICE_CATEGORY.VERKADA:
        deviceList = verkadaDevicesList || [];
        break;
      case DEVICE_CATEGORY.BUTLR:
        deviceList = butlrDevicesList || [];
        break;
      case DEVICE_CATEGORY.WEBEX:
        deviceList = webexDevicesList || [];
        break;
      default:
        break;
    }

    deviceList = deviceList.filter(item => item.hasPosition);
    return deviceList.length > 0 ? (
      <>
        {deviceList.map((device, index) => (
          <div className="device-item" key={`device-item-${index}`}>
            <div className="device-label">
              <div
                className={`marker-button-container ${!device.hasPosition ? 'not-set-position' : ''
                  }`}
              >
                <div className="marker-button-icon">
                  <DeviceMarker deviceinfo={device} size={24} />
                </div>
                <div className="device-name">{device.device_name}</div>
              </div>
            </div>
            <div
              className={`device-zone ${selectedArea?.area_id === device?.area_id ? 'same-area' : ''
                }`}
            >
              {device.area_id ? device.area_name : '-'}
            </div>
            <div className="button-container">
              {device.area_id ? (
                <>
                  <button
                    className="trash-button"
                    onClick={e => removeDeviceFromArea({ device })}
                  >
                    <svg
                      className="custom-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="add-area-button"
                    onClick={e => addDeviceToArea({ device })}
                  >
                    <svg
                      className="custom-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </>
    ) : (
      <div className="no-data-container">
        {COMMON_TEXT.NO_DATA}
      </div>
    );
  };

  renderAreaList = () => {
    const { areaList } = this.state;

    const areaNameInputOnChange = (area, value) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].area_name = value;
        this.setState({ areaList });
      }
    };

    const editAreaOnClicked = ({ area }) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].isEdit = !areaList[idx].isEdit;
        this.setState({ areaList });
      }
    };

    const areaNameOnClicked = area => {
      const {
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      } = this.state;
      this.orgSelectedVerkadaDevicesList = cloneDeep(verkadaDevicesList);
      this.orgSelectedMerakiDevicesList = cloneDeep(merakiDevicesList);
      this.orgSelectedButlrDevicesList = cloneDeep(butlrDevicesList);
      this.orgSelectedWebexDevicesList = cloneDeep(webexDevicesList);
      this.setState({
        selectedArea: cloneDeep(area),
        isDeviceAreaDialogVisible: true,
      });
    };

    const removeArea = ({ area }) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].position_x = null;
        areaList[idx].is_deleted = true;
        this.setState({ areaList });
      }
    };

    const deleteAreaOnClicked = area => {
      confirmDialog({
        message: () => (
          <div className="delete-message-container" style={{ width: '100%' }}>
            <h5>このマーカーを地図から削除しますか？</h5>
            <div
              className="mt-4 flex align-items-center"
              style={{
                paddingBottom: '0.25rem',
              }}
            >
              <div style={{ width: '70px' }}>{`${COMMON_TEXT.NAME}`}</div>
              <div>
                <b>{`${area.area_name}`}</b>
              </div>
            </div>
          </div>
        ),
        header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
        icon: '',
        accept: () => {
          removeArea({ area });
        },
        reject: () => { },
        acceptClassName: 'p-button-danger',
        rejectClassName: 'p-button-secondary p-button-text',
        appendTo: 'self',
      });
    };

    const displayAreaList = areaList.filter(area => !area.is_deleted);

    return (
      <>
        {displayAreaList.length > 0 ? (
          <div className="new-area-list">
            {displayAreaList.map((area, index) => (
              <div className="new-area-item" key={`area-${index}`}>
                <div className="area-indicator">
                  <div className="green-dot"></div>
                </div>
                <div className="area-info">
                  {area.isEdit ? (
                    <InputText
                      value={area.area_name}
                      className="area-name-input"
                      onChange={e =>
                        areaNameInputOnChange(area, e.target.value)
                      }
                    />
                  ) : (
                    <Button
                      className="area-name-button"
                      onClick={e => areaNameOnClicked(area)}
                      text
                      label={area.area_name}
                      severity="secondary"
                    />
                  )}
                  {area.is_new && <span className="new-indicator">*</span>}
                </div>
                <div className="area-actions">
                  <Button
                    className="edit-action-button"
                    onClick={e => editAreaOnClicked({ area })}
                    text
                    severity="secondary"
                  >
                    {area.isEdit ? (
                      <i className="pi pi-check" />
                    ) : (
                      <img
                        src="assets/img/edit-icon.svg"
                        alt="Edit"
                        className="custom-icon"
                      />
                    )}
                  </Button>
                  {!area.isEdit && (
                    <Button
                      className="delete-action-button"
                      onClick={e => deleteAreaOnClicked(area)}
                      text
                      severity="danger"
                    >
                      <img
                        src="assets/img/trash-icon.svg"
                        alt="Delete"
                        className="custom-icon"
                      />
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data-container">
            {COMMON_TEXT.NO_DATA}
          </div>
        )}
      </>
    );
  };

  renderNewAreaList = () => {
    const { areaList } = this.state;

    const areaNameInputOnChange = (area, value) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].area_name = value;
        this.setState({ areaList });
      }
    };

    const editAreaOnClicked = ({ area }) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].isEdit = !areaList[idx].isEdit;
        this.setState({ areaList });
      }
    };

    const areaNameOnClicked = area => {
      const {
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      } = this.state;
      this.orgSelectedVerkadaDevicesList = cloneDeep(verkadaDevicesList);
      this.orgSelectedMerakiDevicesList = cloneDeep(merakiDevicesList);
      this.orgSelectedButlrDevicesList = cloneDeep(butlrDevicesList);
      this.orgSelectedWebexDevicesList = cloneDeep(webexDevicesList);
      this.setState({
        selectedArea: cloneDeep(area),
        isDeviceAreaDialogVisible: true,
      });
    };

    const removeArea = ({ area }) => {
      const idx = areaList.findIndex(a => a.area_id === area.area_id);
      if (idx !== -1) {
        areaList[idx].position_x = null;
        areaList[idx].is_deleted = true;
        this.setState({ areaList });
      }
    };

    const deleteAreaOnClicked = area => {
      confirmDialog({
        message: () => (
          <div className="delete-message-container" style={{ width: '100%' }}>
            <h5>このマーカーを地図から削除しますか？</h5>
            <div
              className="mt-4 flex align-items-center"
              style={{
                paddingBottom: '0.25rem',
              }}
            >
              <div style={{ width: '70px' }}>{`${COMMON_TEXT.NAME}`}</div>
              <div>
                <b>{`${area.area_name}`}</b>
              </div>
            </div>
          </div>
        ),
        header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
        icon: '',
        accept: () => {
          removeArea({ area });
        },
        reject: () => { },
        acceptClassName: 'p-button-danger',
        rejectClassName: 'p-button-secondary p-button-text',
        appendTo: 'self',
      });
    };

    const displayAreaList = areaList.filter(area => !area.is_deleted);

    return (
      <>
        {displayAreaList.length > 0 ? (
          <div className="new-area-list" ref={this.areaListContainerRef}>
            {displayAreaList.map((area, index) => (
              <div className="new-area-item" key={`area-${index}`}>
                <div className="area-indicator">
                  <div className="green-dot"></div>
                </div>
                <div className="area-info">
                  {area.isEdit ? (
                    <InputText
                      value={area.area_name}
                      className="area-name-input"
                      onChange={e =>
                        areaNameInputOnChange(area, e.target.value)
                      }
                    />
                  ) : (
                    <Button
                      className="area-name-button"
                      onClick={e => areaNameOnClicked(area)}
                      text
                      label={area.area_name}
                      severity="secondary"
                    />
                  )}
                  {area.is_new && <span className="new-indicator">*</span>}
                </div>
                <div className="area-actions">
                  <Button
                    className="edit-action-button"
                    onClick={e => editAreaOnClicked({ area })}
                    text
                    severity="secondary"
                  >
                    {area.isEdit ? (
                      <i className="pi pi-check" />
                    ) : (
                      <img
                        src="assets/img/edit-icon.svg"
                        alt="Edit"
                        className="custom-icon"
                      />
                    )}
                  </Button>
                  {!area.isEdit && (
                    <Button
                      className="delete-action-button"
                      onClick={e => deleteAreaOnClicked(area)}
                      text
                      severity="danger"
                    >
                      <img
                        src="assets/img/trash-icon.svg"
                        alt="Delete"
                        className="custom-icon"
                      />
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data-container">
            {COMMON_TEXT.NO_DATA}
          </div>
        )}
      </>
    );
  };

  addNewArea = () => {
    const { areaList, selectedFloorBranch } = this.state;
    const defaultPosition = {
      position_x: 0.4,
      position_y: 0.4,
      position_x1: 0.6,
      position_y1: 0.6,
    };
    const { pointC, width, height } = calculateRectangle({
      positionX: defaultPosition.position_x,
      positionY: defaultPosition.position_y,
      positionX1: defaultPosition.position_x1,
      positionY1: defaultPosition.position_y1,
    });
    const { x, y } = transformCoordinateBottomLeftToTopLeft({
      x: pointC.x,
      y: pointC.y,
    });
    const rect = {
      top: y,
      left: x,
      width,
      height,
    };
    const defaultArea = {
      area_id: `NEW_AREA_ID_${generateRandomString(6)}`,
      area_name: `area${areaList.length + 1 > 9
        ? areaList.length + 1
        : `0${areaList.length + 1}`
        }`,
      capacity_limit: 0,
      is_new: true,
      floor_id: selectedFloorBranch.floor_id,
      rect: rect,
      newRect: rect,
      device_positions: [],
      ...defaultPosition,
    };
    areaList.push(defaultArea);
    this.setState({ areaList });

    // Scroll to bottom after adding new area
    setTimeout(() => {
      if (this.areaListContainerRef.current) {
        this.areaListContainerRef.current.scrollTop = this.areaListContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  onAreaMarkersChange = ({ areaList: newAreaList }) => {
    const { areaList } = this.state;
    areaList.forEach((area, index) => {
      const newArea = newAreaList.find(item => item.area_id === area.area_id);
      if (newArea) {
        const { newRect } = newArea;
        if (newRect) {
          area.newRect = newRect;
        }
      }
    });
    this.setState({ areaList });
  };

  renderSettingContent() {
    const {
      isLoading,
      isUpdating,
      floorList,
      selectedFloorBranch,
      floorMapUrl,
      floorMapError,
      isFloorMapLoading,
      isLoadingDevice,
      deviceMarkerPositionList,
      areaList,
      showCameraMarkerCategories,
    } = this.state;

    const filteredAreaList = areaList.filter(area => !area.is_deleted);
    let markers = [...deviceMarkerPositionList];
    markers = markers.filter(marker => {
      const { device } = marker;
      if (device) {
        const { deviceCategory } = device;
        return showCameraMarkerCategories.includes(deviceCategory);
      }
      return false;
    });

    const isFloorMapError = !floorMapUrl || floorMapError;

    const markerItemTemplate = option => {
      const markerObj = {
        deviceCategory: option.value,
      };
      return (
        <div className="flex align-items-center justify-content-start column-gap-2">
          <DeviceMarker deviceinfo={markerObj} size={20} />
          <div>{option.label}</div>
        </div>
      );
    };

    return (
      <>
        <div className="setting-content">
          <div className="panel">
            <div className="floor-list-container">
              <div className="title-text">{`${COMMON_TEXT.BRANCH} - ${COMMON_TEXT.FLOOR}`}</div>
              <div className="floor-list">
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  floorList.length > 0 &&
                  floorList.map((floor, index) => (
                    <div
                      key={`floor-item-index-${index}`}
                      className={`floor-item ${selectedFloorBranch?.floor_id === floor.floor_id &&
                        'checked'
                        }`}
                    >
                      <RadioButton
                        inputId={floor.floor_id}
                        name="floor"
                        value={floor}
                        checked={
                          selectedFloorBranch?.floor_id === floor.floor_id
                        }
                        onChange={e =>
                          this.onChangeSelectedFloorAction(e.value)
                        }
                      ></RadioButton>
                      <label htmlFor={floor.floor_id} className="ml-2">
                        {this.getBranchName(floor.branch_id)}
                        {floor.floor_name}
                      </label>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="floor-map-container">
              <div className="title-text">
                <div className="marker-toggle-container">
                  <label>{COMMON_TEXT.DEVICE_DISPLAY}</label>
                  <MultiSelect
                    value={showCameraMarkerCategories}
                    onChange={e =>
                      this.setState({ showCameraMarkerCategories: e.value })
                    }
                    selectAllLabel="すべて表示"
                    itemTemplate={markerItemTemplate}
                    display="chip"
                    placeholder={COMMON_TEXT.SHOW_HIDE_CAMERA}
                    options={this.deviceCategoryOptions}
                    className="w-full"
                    panelClassName="marker-toggle-panel"
                  />
                </div>
              </div>
              <div className="floor-map">
                {isFloorMapLoading || isLoadingDevice ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    {!isFloorMapError && (
                      <ImageAreaMarker
                        bufferLeft={0}
                        bufferTop={0}
                        src={floorMapUrl}
                        markerComponent={this.renderMapMarker}
                        areaMarkerComponent={this.renderAreaMarker}
                        markers={isFloorMapError ? [] : markers}
                        areaMarkers={
                          isFloorMapError ? [] : filteredAreaList || []
                        }
                        onAreaMarkersChange={this.onAreaMarkersChange}
                        isDisableDragMarker={false}
                      />
                    )}
                    <>
                      {isFloorMapError && (
                        <Message
                          severity="error"
                          text={COMMON_TEXT.CANNOT_LOAD_FLOORMAP}
                        />
                      )}
                    </>
                  </>
                )}
              </div>
            </div>
            <div className="area-list-container">
              <div className="title-text">{COMMON_TEXT.AREA_SETTING}</div>
              <div className="area-list">
                {isLoadingDevice ? (
                  <LoadingSpinner />
                ) : (
                  <>{this.renderAreaList()}</>
                )}
              </div>
            </div>
          </div>
          <div className="button-container">
            <Button
              type="submit"
              severity="info"
              label="保存"
              loading={isUpdating}
              className="submit-button has-shadow"
              onClick={this.updateButtonOnClicked}
            />
          </div>
        </div>
      </>
    );
  }

  renderUpdatePayloadTable = () => {
    const { floorList } = this.state;
    const tableValues = [];
    // loop through payloadTableData
    for (const floorId in this.payloadTableData) {
      let floorName = '';
      const floor = floorList.find(item => item.floor_id === +floorId);
      if (floor) {
        floorName = floor.floor_name;
      }
      const payloadValues = this.payloadTableData[+floorId];
      if (payloadValues) {
        const { newAreaList, deletedAreaList, modifiedAreaList } =
          payloadValues;
        newAreaList.forEach(item => {
          tableValues.push({
            floor_name: floorName,
            area_name: item.area_name,
            status: UPDATE_AREA_STATUS.NEW,
          });
        });
        deletedAreaList.forEach(item => {
          tableValues.push({
            floor_name: floorName,
            area_name: item.area_name,
            status: UPDATE_AREA_STATUS.DELETED,
          });
        });
        modifiedAreaList.forEach(item => {
          tableValues.push({
            floor_name: floorName,
            area_name: item.area_name,
            status: UPDATE_AREA_STATUS.MODIFIED,
          });
        });
      }
    }

    const statusBodyTemplate = rowData => {
      return (
        <Tag
          value={getTextStatus(rowData.status)}
          severity={getSeverityStatus(rowData.status)}
        />
      );
    };

    const getTextStatus = status => {
      switch (status) {
        case UPDATE_AREA_STATUS.DELETED:
          return COMMON_TEXT.STATUS_DELETED;

        case UPDATE_AREA_STATUS.MODIFIED:
          return COMMON_TEXT.STATUS_MODIFIED;

        case UPDATE_AREA_STATUS.NEW:
          return COMMON_TEXT.STATUS_NEW;

        default:
          return '';
      }
    };

    const getSeverityStatus = status => {
      switch (status) {
        case UPDATE_AREA_STATUS.DELETED:
          return 'danger';

        case UPDATE_AREA_STATUS.MODIFIED:
          return 'warning';

        case UPDATE_AREA_STATUS.NEW:
          return 'info';

        default:
          return 'info';
      }
    };

    return (
      <div className="payload-info-container">
        <DataTable
          value={tableValues}
          rowGroupMode="rowspan"
          groupRowsBy="floor_name"
          sortOrder={0}
          scrollable
          scrollHeight="400px"
          header={null}
          tableStyle={{ width: '100%' }}
          size="small"
        >
          <Column
            field="floor_name"
            header={COMMON_TEXT.FLOOR}
            style={{}}
          ></Column>
          <Column
            field="area_name"
            header={COMMON_TEXT.DEVICE}
            style={{}}
          ></Column>
          <Column
            field="status"
            header={COMMON_TEXT.STATUS}
            body={statusBodyTemplate}
            style={{}}
          ></Column>
        </DataTable>
      </div>
    );
  };

  render() {
    const {
      isUpdateDialogVisible,
      isDeviceAreaDialogVisible,
      selectedArea,
      updateDataPayload,
      isUpdating,
      selectedDeviceCategory,
      isLoading,
      floorList,
      selectedFloorBranch,
      floorMapUrl,
      floorMapError,
      isFloorMapLoading,
      isLoadingDevice,
      deviceMarkerPositionList,
      areaList,
      showCameraMarkerCategories,
    } = this.state;

    const updateDataDialogFooter = () => {
      return (
        <React.Fragment>
          <Button
            label={COMMON_TEXT.CANCEL}
            icon="pi pi-times"
            text
            disabled={isUpdating}
            severity="secondary"
            onClick={() => this.setState({ isUpdateDialogVisible: false })}
          />
          <Button
            label={COMMON_TEXT.SAVE}
            severity="info"
            className="submit-button has-shadow"
            loading={isUpdating}
            icon="pi pi-check"
            onClick={e => this.saveMarkPosition({ updateDataPayload })}
          />
        </React.Fragment>
      );
    };

    const resetAreaDevice = () => {
      this.setState({
        merakiDevicesList: cloneDeep(this.orgSelectedMerakiDevicesList),
        verkadaDevicesList: cloneDeep(this.orgSelectedVerkadaDevicesList),
        butlrDevicesList: cloneDeep(this.orgSelectedButlrDevicesList),
        webexDevicesList: cloneDeep(this.orgSelectedWebexDevicesList),
        isDeviceAreaDialogVisible: false,
      });
    };

    const updateAreaDeviceButtonOnClicked = () => {
      const {
        selectedArea,
        areaList,
        merakiDevicesList,
        verkadaDevicesList,
        butlrDevicesList,
        webexDevicesList,
      } = this.state;
      this.orgSelectedVerkadaDevicesList = cloneDeep(verkadaDevicesList);
      this.orgSelectedMerakiDevicesList = cloneDeep(merakiDevicesList);
      this.orgSelectedButlrDevicesList = cloneDeep(butlrDevicesList);
      this.orgSelectedWebexDevicesList = cloneDeep(webexDevicesList);
      const areaIndex = areaList.findIndex(
        item => item.area_id === selectedArea.area_id
      );
      if (areaIndex !== -1) {
        areaList[areaIndex].capacity_limit = +selectedArea.capacity_limit;
      }
      this.setState({
        isDeviceAreaDialogVisible: false,
        areaList,
      });
    };

    // Prepare data for new layout
    const filteredAreaList = areaList.filter(area => !area.is_deleted);
    let markers = [...deviceMarkerPositionList];
    markers = markers.filter(marker => {
      const { device } = marker;
      if (device) {
        const { deviceCategory } = device;
        return showCameraMarkerCategories.includes(deviceCategory);
      }
      return false;
    });

    const isFloorMapError = !floorMapUrl || floorMapError;

    const markerItemTemplate = option => {
      const markerObj = {
        deviceCategory: option.value,
      };
      return (
        <div className="flex align-items-center justify-content-start column-gap-2">
          <DeviceMarker deviceinfo={markerObj} size={20} />
          <div>{option.label}</div>
        </div>
      );
    };

    return (
      <>
        <Toast ref={this.toastRef} position="top-center" />
        <ConfirmDialog />

        {/* Update Dialog */}
        <Dialog
          visible={isUpdateDialogVisible}
          style={{ width: '44rem' }}
          breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          header={COMMON_TEXT.AREA_SETTING}
          modal
          className="p-fluid"
          footer={updateDataDialogFooter}
          onHide={() => this.setState({ isUpdateDialogVisible: false })}
          appendTo={'self'}
        >
          <div className="confirmation-content">
            {this.renderUpdatePayloadTable()}
          </div>
        </Dialog>

        {/* Device Area Dialog */}
        <Dialog
          visible={isDeviceAreaDialogVisible}
          style={{ width: '500px', height: '700px' }}
          breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          header={null}
          modal
          className="device-area-dialog-new"
          footer={null}
          onHide={() => {
            resetAreaDevice();
          }}
          appendTo={'self'}
          resizable={false}
          draggable={false}
        >
          {selectedArea && (
            <div className="device-area-dialog-content">
              {/* Header */}
              <div className="dialog-header">
                <h2 className="dialog-title">エリア</h2>
                <Button
                  icon="pi pi-times"
                  className="dialog-close-button"
                  onClick={() => resetAreaDevice()}
                />
              </div>

              {/* Area Name */}
              <div className="area-name-display">
                {selectedArea?.area_name}
              </div>

              {/* Form Section */}
              <div className="form-section">
                <div className="form-row">
                  <CustomDropdown
                    className="device-category-dropdown-new"
                    value={selectedDeviceCategory}
                    options={this.deviceCategoryOptions}
                    onChange={e =>
                      this.setState({ selectedDeviceCategory: e.value })
                    }
                  />

                  <div className="capacity-section">
                    <label className="capacity-label">エリアの定員</label>
                    <div className="capacity-input-container">
                      <InputText
                        value={selectedArea?.capacity_limit}
                        className="capacity-input-new"
                        type="number"
                        onChange={e => {
                          selectedArea.capacity_limit = e.target.value;
                          this.setState({});
                        }}
                      />
                      <div className="capacity-controls">
                        <Button
                          icon="pi pi-chevron-up"
                          className="capacity-btn"
                          text
                          onClick={() => {
                            selectedArea.capacity_limit = Math.max(0, parseInt(selectedArea.capacity_limit || 0) + 1);
                            this.setState({});
                          }}
                        />
                        <Button
                          icon="pi pi-chevron-down"
                          className="capacity-btn"
                          text
                          onClick={() => {
                            selectedArea.capacity_limit = Math.max(0, parseInt(selectedArea.capacity_limit || 0) - 1);
                            this.setState({});
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Device List */}
              <div className="device-list-section">
                <div className="device-list-container-new">
                  {this.renderDeviceListNew({ selectedArea })}
                </div>
              </div>

              {/* Save Button */}
              <div className="dialog-footer-new">
                <SaveButton
                  loading={isUpdating}
                  onClick={() => updateAreaDeviceButtonOnClicked()}
                  label="保存"
                  iconSrc="assets/img/save-setting-icon.svg"
                  iconAlt="Save"
                />
              </div>
            </div>
          )}
        </Dialog>

        {/* Main Layout - New Figma Design */}
        <div className="area-setting-new-layout">
          {/* Two Panel Layout */}
          <div className="area-setting-content">
            {/* Left Panel - #252F55 Container */}
            <div className="left-panel">
              <div className="left-panel-header">
                <h2 className="panel-title">エリア</h2>
                <div className="grid grid-nogutter align-items-center justify-content-end">
                  <SaveButton
                    loading={isUpdating}
                    onClick={this.updateButtonOnClicked}
                    label="保存"
                    iconSrc="assets/img/save-setting-icon.svg"
                    iconAlt="Save"
                  />
                </div>
              </div>
              <div className="branch-floor-section">
                <label className="section-label">拠点 - フロア</label>
                <div className="dropdown-container">
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <CustomDropdown
                      className="branch-floor-dropdown"
                      value={selectedFloorBranch}
                      options={floorList.map(floor => ({
                        label: `${this.getBranchName(floor.branch_id)}${floor.floor_name
                          }`,
                        value: floor,
                      }))}
                      onChange={e => this.onChangeSelectedFloorAction(e.value)}
                      placeholder="フロアを選択"
                    />
                  )}
                </div>
              </div>

              <div className="area-list-section">
                <label className="section-label">エリア</label>
                <div className="area-list-container">
                  {isLoadingDevice ? (
                    <LoadingSpinner />
                  ) : (
                    <>
                      {this.renderNewAreaList()}
                      <div className="add-area-container">
                        <Button
                          label="追加"
                          className="add-area-button"
                          onClick={this.addNewArea}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Right Panel - Map Container */}
            <div className="right-panel">
              <div className="map-container">
                <div className="map-controls">
                  <div className="device-display-dropdown">
                    <CustomMultiSelect
                      label="デバイス表示"
                      hideLabel={true}
                      value={showCameraMarkerCategories}
                      onChange={e =>
                        this.setState({ showCameraMarkerCategories: e.value })
                      }
                      optionLabel="label"
                      options={this.deviceCategoryOptions}
                      itemTemplate={markerItemTemplate}
                      display="chip"
                      placeholder={`デバイス表示 (${showCameraMarkerCategories.length})`}
                      className="device-multiselect"
                      style={{ minWidth: '220px', maxWidth: '520px' }}
                    />
                  </div>
                </div>

                {isFloorMapLoading || isLoadingDevice ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    {!isFloorMapError && (
                      <ImageAreaMarker
                        bufferLeft={0}
                        bufferTop={0}
                        src={floorMapUrl}
                        markerComponent={this.renderMapMarker}
                        areaMarkerComponent={this.renderAreaMarker}
                        markers={isFloorMapError ? [] : markers}
                        areaMarkers={
                          isFloorMapError ? [] : filteredAreaList || []
                        }
                        onAreaMarkersChange={this.onAreaMarkersChange}
                        isDisableDragMarker={false}
                      />
                    )}
                    {isFloorMapError && (
                      <Message
                        severity="error"
                        text={COMMON_TEXT.CANNOT_LOAD_FLOORMAP}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

AreaSetting.propTypes = {};

export default AreaSetting;
